import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title-bar-container" }
const _hoisted_2 = {
  key: 0,
  class: "disabled-box"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-container"
}
const _hoisted_4 = { style: {"position":"relative"} }
const _hoisted_5 = { class: "avatar-row" }
const _hoisted_6 = { class: "user-details-container user-details-container-in-menu" }
const _hoisted_7 = { class: "user-name" }
const _hoisted_8 = { class: "hidden-desktop" }
const _hoisted_9 = { class: "menu-row flex-start" }
const _hoisted_10 = { class: "terms-and-privacy" }
const _hoisted_11 = { class: "grey" }
const _hoisted_12 = { class: "user-details-container hidden-mobile" }
const _hoisted_13 = { class: "user-name" }
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_vwc_list_item = _resolveComponent("vwc-list-item")!
  const _component_vwc_icon = _resolveComponent("vwc-icon")!
  const _component_vwc_menu = _resolveComponent("vwc-menu")!
  const _component_vwc_button = _resolveComponent("vwc-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (!_ctx.isTitleBarHidden())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Avatar, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.isAvatarMenuOpen = !_ctx.state.isAvatarMenuOpen)),
              firstName: _ctx.user.firstName,
              lastName: _ctx.user.lastName
            }, null, 8, ["firstName", "lastName"]),
            _createVNode(_component_vwc_menu, {
              menucorner: "START",
              corner: "TOP_LEFT",
              quick: "",
              absolute: "",
              x: "0",
              y: "0",
              open: _ctx.state.isAvatarMenuOpen,
              onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.isAvatarMenuOpen = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vwc_list_item, {
                  role: "menuitem",
                  class: "first-row",
                  tabindex: "0",
                  "mwc-list-item": ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Avatar, {
                        size: "lg",
                        firstName: _ctx.user.firstName,
                        lastName: _ctx.user.lastName,
                        class: "no-shrink"
                      }, null, 8, ["firstName", "lastName"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
                        ]),
                        _createElementVNode("strong", _hoisted_8, "DID(s): " + _toDisplayString(_ctx.activeExtension.didList && _ctx.activeExtension.didList.length > 0 ? _ctx.activeExtension.didList.join(', ') : 'N/A'), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "separator" }, null, -1)),
                _createVNode(_component_vwc_list_item, {
                  onClick: _ctx.onLogoutClick,
                  role: "menuitem",
                  class: "middle-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_vwc_icon, {
                        type: "quit",
                        size: "small",
                        class: "menu-icon"
                      }),
                      _cache[2] || (_cache[2] = _createTextVNode(" Logout ", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator" }, null, -1)),
                _createVNode(_component_vwc_list_item, {
                  role: "menuitem",
                  class: "last-row middle-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          href: "https://www.vonage.com/legal/",
                          target: "_blank"
                        }, "Terms of Service & Privacy Policy")
                      ], -1)),
                      _createElementVNode("span", _hoisted_11, "Version: " + _toDisplayString(_ctx.appVersion) + " - " + _toDisplayString(_ctx.gitRevision), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["open"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
            ]),
            _createElementVNode("strong", null, "Direct Dial Number(s): " + _toDisplayString(_ctx.activeExtension.didList && _ctx.activeExtension.didList.length > 0 ? _ctx.activeExtension.didList.join(', ') : 'N/A'), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isActionButtonHidden())
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, i) => {
            return (_openBlock(), _createBlock(_component_vwc_button, {
              class: "title-bar-button",
              onClick: ($event: any) => (_ctx.onClick(button)),
              key: i,
              icon: (button.icon || '').replace('Vlt-icon-', ''),
              layout: button.outline ? 'outlined' : 'filled',
              shape: 'pill'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(button.text), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "icon", "layout"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}